(function () {
    "use strict";

    // Handle accordion toggle and mark as read
    document.addEventListener('click', function (e) {
        const summary = e.target.closest('.user-notification-summary');
        if (summary) {
            e.preventDefault();
            const item = summary.closest('.user-notification-item');
            if (!item) return;

            const body = item.querySelector('.user-notification-body');
            const toggleIcon = item.querySelector('.user-notification-toggle');
            const container = item.closest('.negarshop-notifications-container');
            const nonce = container ? container.getAttribute('data-nonce') : '';

            if (body) {
                const isExpanded = body.style.display === 'block';

                if (isExpanded) {
                    body.style.display = 'none';
                    if (toggleIcon) toggleIcon.classList.remove('expanded');
                } else {
                    body.style.display = 'block';
                    if (toggleIcon) toggleIcon.classList.add('expanded');
                    
                    // Mark as read if unread
                    if (item.classList.contains('unread')) {
                        const notificationId = item.getAttribute('data-id');
                        
                        const formData = new URLSearchParams();
                        formData.append('action', 'negarshop_mark_notification_read');
                        formData.append('notification_id', notificationId);
                        formData.append('nonce', nonce);

                        fetch(NS_OBJ.ajax_url, {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        })
                        .then(res => res.json())
                        .then(response => {
                            if (response.success) {
                                item.classList.remove('unread');
                                updateUnreadBadges(1);
                            }
                        })
                        .catch(err => console.error('Error marking notification as read:', err));
                    }
                }
            }
            return;
        }

        // Handle mark all as read
        const markAllBtn = e.target.closest('#ns-mark-all-read');
        if (markAllBtn) {
            e.preventDefault();
            const container = markAllBtn.closest('.negarshop-notifications-container');
            const nonce = container ? container.getAttribute('data-nonce') : '';

            markAllBtn.disabled = true;
            const originalText = markAllBtn.textContent;
            markAllBtn.textContent = 'در حال انجام...';

            const formData = new URLSearchParams();
            formData.append('action', 'negarshop_mark_notification_read');
            formData.append('notification_id', 'all');
            formData.append('nonce', nonce);

            fetch(NS_OBJ.ajax_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    document.querySelectorAll('.user-notification-item.unread').forEach(item => {
                        item.classList.remove('unread');
                    });
                    // Clear all badges
                    clearUnreadBadges();
                    markAllBtn.remove();
                } else {
                    markAllBtn.disabled = false;
                    markAllBtn.textContent = originalText;
                }
            })
            .catch(err => {
                console.error('Error marking all as read:', err);
                markAllBtn.disabled = false;
                markAllBtn.textContent = originalText;
            });
            return;
        }
    });

    // Helper to decrement unread badges on the page
    function updateUnreadBadges(decrementBy) {
        // Update My Account menu badge if present
        const accountMenuLink = document.querySelector('li.woocommerce-MyAccount-navigation-link--user-notifications a');
        if (accountMenuLink) {
            const match = accountMenuLink.textContent.match(/\((\d+)\)/);
            if (match) {
                const currentCount = parseInt(match[1], 10);
                const newCount = Math.max(0, currentCount - decrementBy);
                if (newCount > 0) {
                    accountMenuLink.textContent = accountMenuLink.textContent.replace(/\(\d+\)/, `(${newCount})`);
                } else {
                    accountMenuLink.textContent = accountMenuLink.textContent.replace(/\s*\(\d+\)/, '');
                }
            }
        }

        // Update header notification icon badge if exists
        const headerBadge = document.querySelector('.ns-header-notification-badge');
        if (headerBadge) {
            const currentCount = parseInt(headerBadge.textContent, 10);
            const newCount = Math.max(0, currentCount - decrementBy);
            if (newCount > 0) {
                headerBadge.textContent = newCount;
            } else {
                headerBadge.remove();
            }
        }
    }

    // Helper to clear all unread badges
    function clearUnreadBadges() {
        const accountMenuLink = document.querySelector('li.woocommerce-MyAccount-navigation-link--user-notifications a');
        if (accountMenuLink) {
            accountMenuLink.textContent = accountMenuLink.textContent.replace(/\s*\(\d+\)/, '');
        }

        const headerBadge = document.querySelector('.ns-header-notification-badge');
        if (headerBadge) {
            headerBadge.remove();
        }
    }
})();
